// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"b3ed153e","252":"208d5a11","453":"7756b741","513":"b9c991e2","918":"78de3013"}[chunkId] + ".chunk.js";
};